module.exports = __webpack_public_path__ + "static/media/markerfavicon.a2e9d489.ico";